import { COMPONENTS } from '../../lib/constants';

export const ReelHolderView = {
	name: COMPONENTS.REEL,
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'reel_bg_holder',
			type: 'Sprite',
			components: [
				{
					name: 'reel_bg_1',
					type: 'ActionButton',
					hover: false,
					components: [
						{
							name: 'reel_bg',
							type: 'Sprite',
							img: 'reel_bg'
						}
					]
				}
			]
		}
	]
};
